import { EdgeListUplandSpeciesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListUplandSpecies } from '@/shared/domain/use-cases'

export function makeListUplandSpecies(): ListUplandSpecies {
  return new EdgeListUplandSpeciesRepository(makeSupabaseEdgeHttpClient()).execute
}
